import { ArrowDownTrayIcon, PrinterIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"
import React from "react"
import { twMerge } from "tailwind-merge"

import { useIntakeFormPdfExport } from "./useIntakeFormPdfExport"

export { useIntakeFormPdfExport }

export default function IntakeFormPdfActions({
  surveyJson,
  getSurveyJson,
  responseData,
  formName,
  licenseKey,
  className,
  onError
}) {
  const { busyAction, runExport } = useIntakeFormPdfExport({
    surveyJson,
    getSurveyJson,
    responseData,
    formName,
    licenseKey,
    onError
  })

  const buttonClassName =
    "inline-flex items-center gap-1.5 rounded border border-gray-300 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"

  return (
    <div className={twMerge("flex flex-wrap items-center gap-2", className)}>
      <button type="button" className={buttonClassName} disabled={!!busyAction} onClick={() => runExport("download")}>
        <ArrowDownTrayIcon className="size-4" aria-hidden="true" />
        {busyAction === "download" ? "Downloading…" : "Download PDF"}
      </button>
      <button type="button" className={buttonClassName} disabled={!!busyAction} onClick={() => runExport("print")}>
        <PrinterIcon className="size-4" aria-hidden="true" />
        {busyAction === "print" ? "Preparing…" : "Print"}
      </button>
    </div>
  )
}

IntakeFormPdfActions.propTypes = {
  surveyJson: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  getSurveyJson: PropTypes.func,
  responseData: PropTypes.object,
  formName: PropTypes.string,
  licenseKey: PropTypes.string,
  className: PropTypes.string,
  onError: PropTypes.func
}
